import defaultImg from "~/assets/images/default.jpg";
export const PRODUCTION = 'production';
export const DEVELOPMENT = 'development';
// console.log(process.env.NODE_ENV);
export const isProduction = process.env.NODE_ENV === PRODUCTION;
export const isStaging = false;
export const isLocal = false;
// export const isProduction = process.env.NODE_ENV === PRODUCTION;
export const fetchDummyData = false;
// export const fetchDummyData = process.env.NODE_ENV === DEVELOPMENT;
export const oldServer = 'https://3dbia.manamapps.com/api/v1/'
const url = isStaging ? 'https://3dbia.dev/' : 'https://3dbia.com/' ;
export const authApiUrl = url + 'api/users/';
export const notificationsApiUrl = url + 'api/notifications/';
export const uploadsServer = url + 'api/uploads/';
export const dataServer = isLocal ? 'http://localhost:3000/api/data/' : url + 'api/data/';
export const aiServer = isLocal ? 'http://localhost:3000/api/llm/' : url + 'api/llm/';
export const imgPlaceholder = defaultImg;